<template>
    <div class="about">
        <div v-for="history in histories" class="" :key="history.id">
            <span class="float-right text-capitalize">{{ history.scan_type }}</span>
            <div class="info">
                <b>{{ history.date_in }}</b> {{ history.time_in }} <span v-if="history.temp"> | <b>{{ history.temp }}</b></span>
            </div>
            <div class="merchant font-weight-bold">
                {{ history.branch_name }}
            </div>
            <div class="address">
                {{history.branch_address }}
            </div>
            <button v-if="history.digital_brochures.length > 0" class="btn btn-primary btn-sm float-right" @click.prevent="viewImage(history.digital_brochures)">{{ lang('More Info') }}</button>
            <div class="ref">
                {{ history.reference_no_master }}
            </div>
            <hr>
        </div>

        <div id="image-viewer">
            <span class="close" @click="closeBrochure()">&times;</span>
        </div>
        <div v-if="state.loading_next" class="text-center">
            Loading..
        </div>
        <loader v-if="state.loading_auth || state.loading_history"></loader>
    </div>
</template>

<script>
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';
import 'owl.carousel';

import PinchZoom from 'pinch-zoom-js';

export default {
    props: ['branch_ref_no'],

    data() {
        return {
            histories: [],
            next_page: '',

            digital_brochures: [],

            qr_code_data: '',
        }
    },

    watch:{
        $route (to, from){
            this.getHistory()
        }
    },

    methods: {
        verifyToken() {
            this.$set(this.state, 'loading_auth', true)
            if (this.$route.query.qr_code_data) {
                sessionStorage.qr_code_data = this.$route.query.qr_code_data;
            }
            axios.post(this.GLOBAL.API_BASE_URL + "customer-details", {
                    token: localStorage.token
                })
                .then(response => {
                    if(response.data.status == 'OK') {
                        axios.defaults.headers.common['Authorization'] = 'Bearer '+ localStorage.token;
                        window.history.replaceState({}, document.title, "/");
                        if(sessionStorage.qr_code_data) {
                            this.qr_code_data = sessionStorage.qr_code_data;
                            this.getMerchantBranch()
                            sessionStorage.qr_code_data = ''
                        } else {
                            this.getHistory()
                        }

                    } else {
                        Swal.fire({
                            text: 'Session expired',
                            timer: 5000,
                            onClose: () => {
                                this.closeApp()
                            }
                        })
                    }
                })
                // .catch(error=>defaultErrorManagement(error.response)) //to catch the errors if any
                .finally(() => this.$set(this.state, 'loading_auth', false))
        },

        getHistory() {
            this.$set(this.state, 'loading_history', true)
            axios.get(this.GLOBAL.API_BASE_URL +"branch-visit" + (this.branch_ref_no ? '?branch_ref_no='+this.branch_ref_no : ''))
                .then(response => {
                    this.histories = response.data.data
                    this.next_page = response.data.next_page_url

                    this.getNextHistoryPage()
                })
                .catch(error=>defaultErrorManagement(error.response)) //to catch the errors if any
                .finally(() => this.$set(this.state, 'loading_history', false))
        },

        getNextHistoryPage() {
            let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= document.documentElement.offsetHeight

            if(this.next_page && bottomOfWindow) {
                this.$set(this.state, 'loading_next', true)
                axios.get(this.next_page)
                    .then(response => {
                        this.histories.push.apply(this.histories, response.data.data)
                        this.next_page = response.data.next_page_url
                        this.getNextHistoryPage()
                    })
                    .catch(error=>defaultErrorManagement(error.response))
                    .finally(() => this.$set(this.state, 'loading_next', false))

                this.next_page = ''
            }
        },

        viewImage(images) {
            if(images.length > 0) {
                this.digital_brochures = images
                $('#image-viewer').show();
                this.$nextTick(() => {
                    this.initianteCarousel()
                })
            }
        },

        initianteCarousel() {
            $('.owl-carousel').owlCarousel('destroy');
            $('.owl-carousel').remove();
            $('#image-viewer').append('<div class="owl-carousel owl-theme"></div>');
            this.digital_brochures.forEach((brochure) => {
                $(".owl-carousel").append('<div class="item m-auto" style="height: 70vh; width: 90vw;"><img id="item-'+ brochure.id +'" src="'+ brochure.url +'" /></div>');

                let el = document.querySelector('#item-'+ brochure.id);
                let instance = new PinchZoom(el, {
                    // zoom factor
                    tapZoomFactor: 2,
                    // zoom out factor
                    zoomOutFactor: 1.3,
                    // duration in ms
                    animationDuration: 300,
                    // min/max zoom level
                    maxZoom: 4,
                    minZoom: 0.5,
                    // draggable unzoomed image
                    draggableUnzoomed: false,
                    // locks panning of the element to a single axis
                    lockDragAxis: false,
                    // compute offsets only once
                    setOffsetsOnce: false,
                    // falls back to 2D transforms when idle
                    use2d: true,
                    // vertical/horizontal padding
                    verticalPadding: 0,
                    horizontalPadding: 0
                });
            });
            $('.owl-carousel').owlCarousel({
                loop:false,
                margin:10,
                nav:true,
                responsive:{
                    0:{
                        items:1
                    },
                }
            })
            $('.owl-carousel').owlCarousel('refresh');
        },

        closeBrochure() {
            $('#image-viewer').hide();
        }
    },

    created() {
        this.getHistory()

        window.scrollTo(0, 0);

        window.onscroll = () => {
            this.getNextHistoryPage()
        }
    },

    beforeRouteLeave(to, from, next) {
        if(to.name == 'auth') {
            this.closeApp()
        } else {
            next()
        }
    }
}

</script>

<style scoped>

/* The Modal (background) */
#image-viewer {
    display: none;
    position: fixed;
    z-index: 10;
    padding-top: 100px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.9);
}
.modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
}
.modal-content { 
    animation-name: zoom;
    animation-duration: 0.6s;
}
@keyframes zoom {
    from {transform:scale(0)} 
    to {transform:scale(1)}
}
#image-viewer .close {
    position: absolute;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
}
#image-viewer .close:hover,
#image-viewer .close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
}

@media only screen and (max-width: 700px){
    .modal-content {
        width: 100%;
    }
}

.pinch-zoom-parent,
.owl-carousel .item {
    height: 80vh;
    width: 90vw;
}
</style>